import {
  ApolloClient,
  InMemoryCache,
  NormalizedCacheObject,
  ApolloLink,
  HttpLink,
  onError
} from '@do/seashell/graphql';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import {
  APOLLO_CLIENT_NAME,
  APOLLO_CLIENT_VERSION,
  NETWORK_ERROR_CODE,
  PUBLIC_ENDPOINT
} from './constants';

export const createClient = (
  uri: string
): ApolloClient<NormalizedCacheObject> => {
  const linkConfig: { uri: string } = {
    uri
  };

  return new ApolloClient({
    link: ApolloLink.from([
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          window.console.log('graphql Errors', graphQLErrors);
        }
        if (networkError) {
          // Handle Cloudflare Bot Management Captcha redirect
          if (
            _get(networkError, 'statusCode') === NETWORK_ERROR_CODE &&
            (_includes(_get(networkError, 'bodyText'), 'captcha-bypass') ||
              _includes(
                _get(networkError, 'bodyText'),
                'keep DigitalOcean bot-free'
              ))
          ) {
            const challengePath = `${window.location.origin}/graphql/public/test`;
            const challenge = `challenge=${window.location.pathname}`;
            const s = window.location.search;
            const challengeUri = s.length
              ? `${challengePath}${s}&${challenge}`
              : `${challengePath}?${challenge}`;

            window.location.replace(challengeUri);
          } else {
            window.console.log('network Errors', networkError);
          }
        }
      }),

      new HttpLink(linkConfig)
    ]),
    cache: new InMemoryCache({}),
    assumeImmutableResults: true,
    name: APOLLO_CLIENT_NAME,
    version: APOLLO_CLIENT_VERSION
  });
};

const client = createClient(process.env.GRAPHQL_URL || PUBLIC_ENDPOINT);

export default client;
